<template>
    <div v-loading="loading">
        <div style="line-height: 49px;height: 49px;">
            <button @click="saveRoleRegion()" style="float: right;margin-top: 8px;" class='swb-btn swb-btn-small mr15'>
                <span>保存</span>
            </button>
        </div>
        <swb-region-select :regionList="regionList" :isShowDiv="false" ref="swb_region_select"></swb-region-select>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import servicerAuthxApi from '../../api/servicerAuthx'
    import userApi from '../../api/user'
    import goodsCategApi from '../../api/goodsCateg'
    //
    import SwbRegionSelect from '../comn/RegionSelect';
    Vue.regist(SwbRegionSelect);
    export default {
        name: 'swb-com-role-region',
        desc: '公司岗位-商品分类',
        props: {
            roleId: {
                type: Number,
                default: null
            },
            roleName: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                loading: false,
                regionList: []
            }
        },
        created: function () {
            //
            this.getComRoleRegionList(this.roleId);
        },
        methods: {
            getComRoleRegionList: function (roleId) {
                let self = this;
                let postData = {};
                postData.roleId = roleId;
                servicerAuthxApi.getServicerComRoleRegionList(postData, function (result) {
                    if(result.type === 'info') {
                        let roleRegionList = result.data;
                        self.regionList = roleRegionList;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            saveRoleRegion: function () {
                let result = this.$refs.swb_region_select.getDlgResult() || {};
                if(result.type == "info") {
                    let regionList = result.data;
                    if(regionList == null || regionList.length <= 0) {
                        this.$message.warning("请至少选择一个地区");
                    }
                    let regionIds = [];
                    for(var i = 0; i < regionList.length; i++) {
                        regionIds.push(regionList[i].regionId);
                    }
                    let postData = {};
                    postData.roleId = this.roleId;
                    postData.regionIds = regionIds;
                    //
                    let self = this;
                    self.loading = true;
                    servicerAuthxApi.saveServicerComRoleRegion(postData, function (result) {
                        self.loading = false;
                        if(result.type === 'info') {
                            self.getComRoleRegionList();
                        } else {
                            self.$message.error(result.message);
                        }
                    });
                    //
                } else {
                    this.$message.warning(result.message);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/ComRoleRegion.vue